import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MapConfigService, injectMapFeatureConfig } from '@navfleet/client/map/domain/data-access';
import { MAP_FEATURE_CONFIG, MapFeatureContribution } from '@navfleet/client/map/domain/models';
import {
    MAP_TOOLS_FEATURE_KEY,
    MapToolsConfig,
    overrideMapToolsConfig,
} from '@navfleet/client/map/tools/domain/models';
import { Observable } from 'rxjs';

// Re-exported from the models lib, so map configs in models and ui libs can use them
export { MAP_TOOLS_FEATURE_KEY, overrideMapToolsConfig };

/** Typed accessor for the merged feature config (defaults + container override). */
export const injectMapToolsConfig = (): Observable<MapToolsConfig> =>
    injectMapFeatureConfig<MapToolsConfig>(MAP_TOOLS_FEATURE_KEY);

/**
 * Pure variant — use only when you already hold a MapConfigService reference
 * (e.g. inside another service that received it via constructor).
 */
export const getMapToolsConfig = (service: MapConfigService): Observable<MapToolsConfig> =>
    service.getFeatureConfig(MAP_TOOLS_FEATURE_KEY) as Observable<MapToolsConfig>;

/** Default config contributed at app bootstrap. */
const DEFAULT_TOOLS: MapToolsConfig = {
    enabled: true,
};

/** Multi-provider registration. Call this once in ClientShellModule (or equivalent). */
export function provideMapToolsFeature(overrides: Partial<MapToolsConfig> = {}): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: MAP_FEATURE_CONFIG,
            multi: true,
            useValue: {
                [MAP_TOOLS_FEATURE_KEY]: { ...DEFAULT_TOOLS, ...overrides },
            } satisfies MapFeatureContribution,
        },
    ]);
}
